<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix" style="text-align:center;">
                <a style="text-decoration:none;color:#337ab7;cursor:pointer; float: left; line-height: 36px;" @click="returnBack">返回</a>
                <span style="line-height: 36px;">{{addType === 'edit' ? '编辑' : '新建'}}设备用户入口</span>
            </div>
            <div class="card-body" style="text-align:left;">
                <div class="item-list">
                    <div class="item-left">
                        <span>入口公众号</span>
                    </div>
                    <el-select v-if="addType === 'edit'" class="item-right" v-model="urlName" disabled :placeholder="urlName">
                        <el-option
                            v-for="item in weixinList"
                            :key="item.nick_name"
                            :label="item.nick_name"
                            :value="item.appid">
                        </el-option>
                    </el-select>
                    <el-select v-if="addType === 'add'" class="item-right" v-model="weixinAppId" clearable placeholder="请选择">
                        <el-option
                            v-for="item in weixinList"
                            :key="item.nick_name"
                            :label="item.nick_name"
                            :value="item.appid">
                        </el-option>
                    </el-select>
                </div>
                <div class="item-list">
                    <div class="item-left">
                        <span>请选择设备</span>
                    </div>
                    <el-button class="item-right" type="info" @click="btnOpenSelectPop()">选择设备</el-button>
                    <ad-select-device 
                        v-if="selectPopShow"
                        @closeSelectDevicePop="closeSelectDevicePop"
                        :chooseDeviceCodes = "selectedDevices"
                    ></ad-select-device>
                </div>
                <div>
                    <el-tag
                        v-for="deviceCode in selectedDevices"
                        :key="deviceCode"
                        :closable="true"
                        type="success"
                        :close-transition="false"
                        @close="handleClose(deviceCode)"
                        style="margin: 3px 5px;"
                        > 
                        {{deviceCode}}  
                    </el-tag>
                </div>
                <div style="text-align: center">
                    <el-button class="item-right" type="info" :loading="btnLogin" @click="btnSave()">保存</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
  import $ajax from '../../https/config'
  import adSelectDevice from '@/page/adMgr/adSelectDevice'
  import {isNull} from '../../js/tool'

  export default {
    data () {
      return {
        weixinList: [],
        weixinAppId: '',
        selectPopShow: false,
        selectedDevices: [],
        addType: this.$route.query.type,
        urlId: this.$route.query.id,
        urlAppid: this.$route.query.appid,
        urlName: this.$route.query.name,
        btnLogin: false
      }
    },
    created: function () {
      if (this.addType === 'add') {
        this.getPublic()
      } else {
        this.weixinAppId = this.urlAppid
        this.getDeviceCodeList(this.weixinAppId)
      }
    },
    methods: {
      getPublic: function () {
        var url = '/para/getWxPublicList'
        var _this = this
        $ajax.get(url, null, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            var resData = []
            if (res.resultData && res.resultData.length > 0) {
              for (var i = 0; i < res.resultData.length; i++) {
                resData.push({
                  nick_name: res.resultData[i].nick_name,
                  appid: res.resultData[i].appid
                })
              }
              _this.weixinList = resData
            } else {
            }
            _this.table_loading = false
          }
        }, function () {})
      },
      getDeviceCodeList: function (tAppid) {
        var url = '/para/queryEntranceQrCodeDeviceCodeList'
        var _this = this
        // this.selectedDevices = [100850, 100232, 100359]
        var params = {
          appid: tAppid
        }
        $ajax.get(url, params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            _this.selectedDevices = res.resultData
          } else {
          }
        }, function () {})
      },
      btnOpenSelectPop: function () {
        this.selectPopShow = true
      },
      closeSelectDevicePop: function (val) {
        this.selectPopShow = false
        this.selectedDevices = val
      },
      handleClose: function (deviceCode) {
        this.selectedDevices.splice(this.selectedDevices.indexOf(deviceCode), 1)
      },
      btnSave: function () {
        console.log(this.weixinAppId)
        console.log(this.selectedDevices)
        if (isNull(this.weixinAppId)) {
          this.$message({
            message: '请选择入口公众号',
            type: 'error'
          })
          return false
        }
        if (isNull(this.selectedDevices)) {
          this.$message({
            message: '请选择设备',
            type: 'error'
          })
          return false
        }
        var _this = this
        var params = {
          appid: this.weixinAppId,
          deviceCode: this.selectedDevices.join('|')
        }
        this.btnLogin = true
        $ajax.get('/para/createParamQrcode', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            _this.$message({
              type: 'success',
              message: '新建入口地址成功!'
            })
            setTimeout(function () {
              _this.btnLogin = false
              _this.returnBack()
            }, 1000)
          } else {
            _this.$message({
              type: 'error',
              message: '新建入口地址失败!' + res.errorMessage
            })
            _this.btnLogin = false
          }
        })
      },
      returnBack () {
        this.$router.back(-1)
      }
    },
    components: {
      'ad-select-device': adSelectDevice
    }
  }
</script>
<style lang="scss">
    .card-body .item-list:nth-child(n+2) {
        margin-top: 20px;
    }
    .item-list {
        display: inline-block;
        width: 100%;

        .item-left, .item-right {
            float: left;
            text-align: left;
           
        }

        .item-left {
             margin-right: 30px;
            span {
                vertical-align:sub;
                vertical-align:-webkit-baseline-middle;
            }
        } 
    }
</style>



// WEBPACK FOOTER //
// src/page/adMgr/addEntryAddress.vue